module.exports = ".error-bg{font-size: 14px; border: solid 1px #ccc; border-radius:4px; background:#d83234; color:#fff; padding:15px; margin-top:30px; line-height: 30px; text-align: center}\n.error-bg h3{font-size: 18px; margin-bottom: 15px; display: block}\n.error-bg .material-icons {font-size: 50px; margin-bottom: 15px}\n.error-bg ol {font-style: italic}"


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error/error.component.css
// module id = ./src/app/error/error/error.component.css
// module chunks = main